import {$, w} from './constants';

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');

    //Cookies
    if(localStorage.getItem('jet-bike_cookie')){
        $('#cookie-jet-bike').addClass('hide-cookies');
    }else{
        $('#cookie-jet-bike').delay(1500).fadeIn(500);
        $('#button-cookie').click(() => {
            localStorage.setItem('jet-bike_cookie', 'true');
            $('#cookie-jet-bike').addClass('hide-cookies');
            console.log('Acepto cookies')
        })
    }

    if($('#landing-slider').length){
        $('#landing-slider').slick({
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 701,
                    settings: "unslick"
                  }
            ]
        });
    }

    if($('.modelos__single-gallery').length){
        const galleries = $('.modelos__single-gallery');

        Array.from(galleries).forEach((gallery) => {
            $(gallery).slick({
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: "<div class='arrow-left'>",
		        nextArrow: "<div class='arrow-right'>",
                dots: true,
                dotsClass: 'dots-single'
            });
        });
    }

    if($('.modelos__slider').length){
        $('.modelos__slider').slick({
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: "<div class='arrow-left arrow-left--more'>",
            nextArrow: "<div class='arrow-right arrow-right--more'>",
            dots: true,
            dotsClass: 'dots-single dots-single--more',
            responsive: [
                {
                    breakpoint: 901,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 601,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');
    //Menú
    if($(window).width() > 900){
        $(window).scroll(function (event) {
            let scroll = $(window).scrollTop();
            let header = $('.header').offset().top;
            if(scroll >= header){
                $('.menu-has-grid').children('a').removeClass('active');
                $('.menu-has-grid').children('.sub-menu').removeClass('show');
                $('.menu-has-submenu').children('a').removeClass('active-sublink');
                $('.menu-has-submenu').children('.sub-menu').removeClass('show');
                $('.header').data('state', 'close');
                $('.header').attr('data-state', 'close');
            }
        });
        $('.menu-hover-image').hover(function() {
            let url_image = $(this).data('image');
            let image = $('.container-image-menu').addClass('show').find('img');
            $(image).attr('src', url_image);
        },function(){
            $('.container-image-menu').removeClass('show');
        });
        const menu_fixed = gsap.timeline();
        if($('.landing').length){
            menu_fixed.to('.menu-scroll-id',{
                scrollTrigger : {
                    trigger: ".landing__services",
                    scrub: true,
                    start : "top-=175",
                    end : "bottom",
                    toggleActions : "restart pause resume pause",
                    markers: false,
                    onEnter : () => {
                        $('.menu-scroll-id').addClass('active');
                    },
                    onLeave : () => {
                        $('.menu-scroll-id').removeClass('active');
                    },
                    onToggle : () => {
                        $('.menu-scroll-id').toggleClass('active');
                    }
                }
            })
        }
    }

    $('.menu-has-grid').click(function(e){
        e.stopPropagation();
        $(this).siblings().find('a').removeClass('active');
        $(this).siblings().find('.sub-menu').removeClass('show');
        $(this).children('a').toggleClass('active');
        $(this).children('.sub-menu').toggleClass('show');
        $('.menu-has-submenu').children('a').removeClass('active-sublink');
        $('.menu-has-submenu').children('.sub-menu').removeClass('show');
    });

    $('.menu-has-submenu').click(function(e){
        e.stopPropagation();
        $('.menu-has-submenu').children('a').removeClass('active-sublink');
        $('.menu-has-submenu').children('.sub-menu').removeClass('show');
        $(this).children('a').toggleClass('active-sublink');
        $(this).children('.sub-menu').toggleClass('show');
    });

    $('.header__hamburger-button').click(function(){
        $(this).toggleClass('open');
        $('.header__main-links').toggleClass('show');
        $('.menu-has-grid').siblings().find('a').removeClass('active');
        $('.menu-has-grid').siblings().find('.sub-menu').removeClass('show');
        $('.menu-has-submenu').children('a').removeClass('active-sublink');
        $('.menu-has-submenu').children('.sub-menu').removeClass('show');
        if($('.header').attr('data-state') === "close"){
            console.log('change to open')
            $('.header').data('state', 'open');
            $('.header').attr('data-state', 'open');
        }else{
            $('.header').data('state', 'close');
            $('.header').attr('data-state', 'close');
        }
    })

    $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        
            if (target.length) {
                event.preventDefault();
                $('.menu-has-grid').siblings().find('a').removeClass('active');
                $('.menu-has-grid').siblings().find('.sub-menu').removeClass('show');
                $('.menu-has-submenu').children('a').removeClass('active-sublink');
                $('.menu-has-submenu').children('.sub-menu').removeClass('show');
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
            }
        }
    });

    //Formulario de contacto
    $("#contact").validate({
        rules: {
            nombre : {
                required: true
            },
            telefono: {
                required: true,
                number: false
            },
            mail: {
                required: true,
                email: true
            }
        },
        messages : {
            nombre: {
                required: "Este campo es obligatorio"
            },
            telefono: {
                required: "Este campo es obligatorio"
            },
            mail: {
                required: "Este campo es obligatorio",
                email: "Ingresa una dirección de correo válida"
            }
        },
        errorClass : "error-contact",
        errorElement: "label",
        submitHandler: function(form) {
            event.preventDefault();
            $('#submit-btn').prop('disabled', true);
            $('#success').removeClass('fadeOut');
            $.ajax({
                url: cltvo_js_vars.ajax_url,
                type: form.method,
                data: $(form).serialize(),
                success: function(response) {
                    $('#nombre').val('');
                    $('#telefono').val('');
                    $('#mail').val('');
                    $('#mensaje').val('');
                    $('#submit-btn').prop('disabled', false);
                    $('#success').addClass('fadeOut');
                    $('#success').html('<span>¡Gracias!</span> Nos comunicaremos contigo a la brevedad');
                }
            });
        }
    });
})

function toScroll(id_element){
    $('html, body').animate(
        {
          scrollTop: $(id_element).offset().top - 120,
        },
        1200,
        'swing'
    )
}
